import { render, staticRenderFns } from "./createFollowupTask.vue?vue&type=template&id=aab003c4&scoped=true&"
import script from "./createFollowupTask.vue?vue&type=script&lang=js&"
export * from "./createFollowupTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab003c4",
  null
  
)

export default component.exports